module.exports = __webpack_public_path__ + "img/cuac.6ecfaeb4.jpg";